import { CommonResponse, DefaultGetParams } from 'src/types';

// ----------------------------------------------------------------------
// Saved AI assistant conversations ("chat history").
//
// The backend stores two transcripts per conversation and never interprets
// either of them: `items` is what the drawer renders, `history` is what the
// model continues from. They are opaque here on purpose — the orchestrator
// owns those shapes, and anything read back off the wire is untrusted until
// it has been validated at the boundary.
// ----------------------------------------------------------------------

/** Bumped when the stored transcript shape changes; older snapshots are dropped. */
export const AI_CHAT_SCHEMA_VERSION = 1;

export type AiChatSortBy = 'updated_at' | 'created_at' | 'title';

export type AiChat = {
  id: string;
  title: string;
  message_count: number;
  created_at: string;
  updated_at: string;
};

export type AiChatTranscript = {
  schema_version: number;
  items: unknown[];
  history: unknown[];
  vault?: unknown;
};

export type AiChatDetail = AiChat & AiChatTranscript;

// ----------------------------------------------------------------------
// Params / forms
// ----------------------------------------------------------------------

export type AiChatsGetParams = DefaultGetParams<AiChatSortBy>;

export type AiChatCreateForm = AiChatTranscript & {
  title: string;
};

export type AiChatUpdateForm = Partial<AiChatTranscript> & {
  id: AiChat['id'];
  title?: string;
};

// ----------------------------------------------------------------------
// Responses
// ----------------------------------------------------------------------

export type AiChatsResponse = CommonResponse<{
  count: number;
  chats: AiChat[];
}>;

export type AiChatDetailResponse = CommonResponse<AiChatDetail>;

export type AiChatMutationResponse = CommonResponse<AiChat>;

export type AiChatDeleteResponse = CommonResponse<{ id: AiChat['id'] }>;
